module.exports = __webpack_public_path__ + "static/media/upload3d_full_not_active.1f333913.svg";